//Import required libraries
import React from "react";
import { NavLink, Link } from "react-router-dom";

//Import Styles
import "./Header.scss";

//Import Data
import socialMediaData from "../../../assets/data/socialMediaData.json";
import routeData from "../../../assets/data/routeData.json";

//Import Store
import { store } from "../../../store/initialState";

let otherPagesData = routeData.filter((obj) => obj.route !== "/about");

const Header = (props) => {
  let { navSticky, pagesFlag } = props;

  //filter based on the boolean display
  let socialMedia = socialMediaData.filter((obj) => obj.display);

  return (
    <>
      {/* <header className="header" id="header">
        <div className="header-content">
          <Link to="/" className="disabled-style">
            <img src={store.photographerUrl} alt="photographer"></img>
          </Link>
        </div>
        <div className="header-content">
          {routeData.map((obj, index) => (
            <span key={index}>
              <NavLink
                to={obj.route}
                activeClassName="active"
                className="disabled-style"
              >
                <span>{obj.title}</span>
              </NavLink>
              {index + 1 !== routeData.length && <span>&nbsp;|&nbsp;</span>}
            </span>
          ))}
        </div>
        <div className="header-content">
          {socialMedia.map((obj, index) => (
            <a key={index} href={obj.href} target="_blank">
              <i className={obj.className} aria-hidden="true"></i>
            </a>
          ))}
        </div>
      </header> */}
      <header className={`header-sticky ${navSticky ? "show" : "hide"}`}>
        <div className="header-sticky-content">
          {/* <Link to="/" className="disabled-style"> */}
            <img src={store.photographerUrl} alt="photographer"></img>
          {/* </Link> */}
          <div className="header-sticky-content">
            {/* {routeData.map((obj, index) => (
              <span key={index}>
                <NavLink
                  to={obj.route}
                  activeClassName="active"
                  className="disabled-style"
                >
                  <span>{obj.title}</span>
                </NavLink>
                {index + 1 !== routeData.length && <span>&nbsp;|&nbsp;</span>}
              </span>
            ))} */}
          </div>
        </div>
        <div className="header-sticky-content">
          {socialMedia.map((obj, index) => (
            <a key={index} href={obj.href} target="_blank">
              <i className={obj.className} aria-hidden="true"></i>
            </a>
          ))}
        </div>
      </header>
    </>
  );
};

export default Header;
